export const billingConversionFunnelConfig = {
	title: 'Conversão de Carrinhos',
	valueLabel: 'Conversão Total',
	trendLabel: 'vs ontem',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingRevenueConfig = {
	title: 'Faturamento',
	subtitle: 'Total de vendas realizadas na plataforma este mês',
	trendLabel: 'vs mês passado',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingAbandonedCartsConfig = {
	title: 'Carrinhos Abandonados',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingSubscriptionsStatusConfig = {
	title: 'Status de Assinaturas',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingContractedPlansListConfig = {
	title: 'Planos Contratados',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingCashFlowConfig = {
	title: 'Fluxo de Caixa Mensal',
	trendLabel: 'vs mês passado',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
};

export const billingExpiringSubscriptionsConfig = {
	title: 'Próximo do Vencimento',
	subtitle: 'Cadastros de clientes próximos de vencer',
	buttonText: 'Ver Relatório',
	onButtonClick: () => {},
	emptyMessage: 'Nenhum vencimento nos próximos 7 dias',
};
